"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  PencilWriteAlternate: ['pencil-write-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20,11.491a1,1,0,0,0-1,1v8.5a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1v-17a1,1,0,0,1,1-1H13a1,1,0,0,0,0-2H3a3,3,0,0,0-3,3v17a3,3,0,0,0,3,3H18a3,3,0,0,0,3-3v-8.5A1,1,0,0,0,20,11.491Z', 'M18.818,3.051a.516.516,0,0,0-.707,0L10.3,10.865a.5.5,0,0,0-.111.168L8.773,14.568a.5.5,0,0,0,.111.539.519.519,0,0,0,.539.11L12.958,13.8a.5.5,0,0,0,.168-.111L20.94,5.88a.5.5,0,0,0,0-.707Z', 'M23.415.577a2.047,2.047,0,0,0-2.828,0L19.526,1.637a.5.5,0,0,0,0,.707l2.12,2.121a.5.5,0,0,0,.707,0l1.061-1.06a2,2,0,0,0,0-2.828Z']],
  QuillWrite1Alternate: ['quill-write-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M4.914,17.67a1,1,0,0,0,0,1.414,1.013,1.013,0,0,0,1.415,0l4.14-4.14a14.576,14.576,0,0,0,9.4-4.1A14.7,14.7,0,0,0,24,1.038a1,1,0,0,0-.292-.744A.981.981,0,0,0,22.962,0a15.214,15.214,0,0,0-6.689,1.823.5.5,0,0,0-.256.505l.35,2.63L14.323,3.588a.5.5,0,0,0-.611.043,13.4,13.4,0,0,0-2.8,3.482,14.9,14.9,0,0,0-1.565,4.238,15.666,15.666,0,0,0-.291,2.179Z', 'M21,13.5a1,1,0,0,0-1,1V21a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V5A1,1,0,0,1,3,4H9A1,1,0,0,0,9,2H3A3,3,0,0,0,0,5V21a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V14.5A1,1,0,0,0,21,13.5Z']],
  PenWrite: ['pen-write', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19,13a1,1,0,0,0-1,1v7a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V3A1,1,0,0,1,3,2h7a1,1,0,0,0,0-2H3A3,3,0,0,0,0,3V21a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V14A1,1,0,0,0,19,13Z', 'M8.73,12.521a.5.5,0,0,0-.353.361L7.82,15.119,6.568,16.371a.75.75,0,0,0,0,1.061.76.76,0,0,0,1.06,0L8.892,16.17l2.207-.555a.5.5,0,0,0,.36-.35.5.5,0,0,0-.127-.487L9.217,12.65A.5.5,0,0,0,8.73,12.521Z', 'M23.707.293a1,1,0,0,0-1.414,0l-.9.9a2.011,2.011,0,0,0-1.533.208l-.052-.051a3,3,0,0,0-4.235.006L11.961,4.961a1,1,0,0,0,0,1.414,1.013,1.013,0,0,0,1.415,0L17,2.761a1,1,0,0,1,1.407.007l-.707.707a.5.5,0,0,0,0,.707L19.818,6.3a.5.5,0,0,0,.707,0l1.768-1.768a2,2,0,0,0,.517-1.93l.9-.9A1,1,0,0,0,23.707.293Z', 'M12.4,14.22a.5.5,0,0,0,.353-.147l6.356-6.355a.5.5,0,0,0,0-.707L16.99,4.889a.514.514,0,0,0-.707,0L9.927,11.245a.5.5,0,0,0,0,.707l2.121,2.121A.5.5,0,0,0,12.4,14.22Z']],
  PencilWrite1Alternate: ['pencil-write-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20,11.488a1,1,0,0,0-1,1v8.5a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1v-17a1,1,0,0,1,1-1H13a1,1,0,0,0,0-2H3a3,3,0,0,0-3,3v17a3,3,0,0,0,3,3H18a3,3,0,0,0,3-3v-8.5A1,1,0,0,0,20,11.488Z', 'M23.415.578a2.048,2.048,0,0,0-2.828,0L19.526,1.639a.5.5,0,0,0,0,.707l2.121,2.121a.5.5,0,0,0,.707,0l1.061-1.061A2,2,0,0,0,23.415.578Z', 'M11.359,10.514l2.121,2.121a.5.5,0,0,0,.707,0l6.364-6.364a.5.5,0,0,0,0-.708L18.429,3.441a.516.516,0,0,0-.707,0L11.359,9.807A.5.5,0,0,0,11.359,10.514Z', 'M10.349,11.235a.506.506,0,0,0-.364.3L8.773,14.57a.5.5,0,0,0,.111.539.529.529,0,0,0,.539.111l3.03-1.212a.5.5,0,0,0,.168-.818L10.8,11.372A.5.5,0,0,0,10.349,11.235Z']],
  QuillCircle: ['quill-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.476,13.244a.75.75,0,0,1,.75-.75h6.086a.254.254,0,0,0,.207-.107c3.057-4.249,4.406-8.924,2.075-11.259a.5.5,0,0,0-.7,0,.453.453,0,0,0-.054.062l-4.688,4.69a.251.251,0,0,1-.427-.177V.994A.5.5,0,0,0,16,.546,30.084,30.084,0,0,0,8.8,6a23.25,23.25,0,0,0-5.368,7.994c-.808,2.171-.91,4.009-.341,5.246L.519,21.805a1,1,0,0,0,0,1.414,1.015,1.015,0,0,0,1.414,0l2.556-2.555a5.5,5.5,0,0,0,2.425.5A14.254,14.254,0,0,0,15.1,17.947a.253.253,0,0,0-.154-.453H9.726a.75.75,0,1,1,0-1.5h7.56a.258.258,0,0,0,.178-.072c.5-.485.983-.991,1.442-1.511a.253.253,0,0,0-.192-.417H14.226A.75.75,0,0,1,13.476,13.244Z']],
  QuillCircle1: ['quill-circle-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.853.149a.5.5,0,0,0-.431-.14A36.56,36.56,0,0,0,18.758,1.15a.506.506,0,0,0-.331.333L17.274,5.272a.248.248,0,0,1-.178.17.252.252,0,0,1-.238-.066l-2.3-2.3a.5.5,0,0,0-.564-.1A23.373,23.373,0,0,0,7.258,7.482C4.683,10.058,3.447,12.5,3.585,14.755a5.578,5.578,0,0,0,1.186,3.062L.293,22.3a1,1,0,0,0,0,1.414,1.014,1.014,0,0,0,1.414,0L12.535,12.882a.75.75,0,1,1,1.061,1.06L7.805,19.734a.249.249,0,0,0,.1.413,6.578,6.578,0,0,0,5.408-.845,16.027,16.027,0,0,0,3.211-2.557C22.307,10.959,23.928,1,23.994.581A.5.5,0,0,0,23.853.149Z']],
  PencilCircle: ['pencil-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0ZM6.036,17.078l1.116-2.792a.523.523,0,0,1,.111-.168l5.892-5.892a.514.514,0,0,1,.707,0L15.538,9.9a.505.505,0,0,1,.146.354.5.5,0,0,1-.146.353L9.645,16.5a.483.483,0,0,1-.168.111L6.686,17.728a.516.516,0,0,1-.54-.111A.5.5,0,0,1,6.036,17.078Zm11.734-8.7-.838.837a.5.5,0,0,1-.707,0L14.55,7.538a.5.5,0,0,1,0-.707l.838-.838A1.677,1.677,0,0,1,16.579,5.5h0a1.685,1.685,0,0,1,1.19,2.876Z']],
  Pencil2: ['pencil-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M2.649,16.4a.5.5,0,0,0-.841.245L.394,23.01a.5.5,0,0,0,.134.462.509.509,0,0,0,.462.135l6.364-1.414a.5.5,0,0,0,.245-.842Z', 'M17.852,7.208,6.892,18.168a.252.252,0,0,0,0,.354L8.66,20.29a.507.507,0,0,0,.707,0L19.974,9.683a.5.5,0,0,0,0-.707L18.206,7.208A.252.252,0,0,0,17.852,7.208Z', 'M16.792,5.794,15.024,4.027a.5.5,0,0,0-.707,0L3.71,14.633a.5.5,0,0,0,0,.707l1.768,1.768a.252.252,0,0,0,.354,0l10.96-10.96A.252.252,0,0,0,16.792,5.794Z', 'M22.449,1.552a4.005,4.005,0,0,0-5.658,0l-.707.707a.5.5,0,0,0,0,.707l4.95,4.949a.513.513,0,0,0,.707,0l.708-.707A4,4,0,0,0,22.449,1.552Z']],
  PencilWrite: ['pencil-write', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.937,15a1.977,1.977,0,0,1-.672.443L9.73,16.86a2.026,2.026,0,0,1-2.157-.442,2,2,0,0,1-.443-2.157l1.413-3.533a2.008,2.008,0,0,1,.444-.673l5.887-5.888A.251.251,0,0,0,14.7,3.74H3.368A3.118,3.118,0,0,0,.25,6.858V20.623A3.117,3.117,0,0,0,3.368,23.74H17.133a3.116,3.116,0,0,0,3.117-3.117V9.294a.25.25,0,0,0-.426-.177Z', 'M18.568,3.3a.514.514,0,0,0-.707,0l-7.813,7.814a.507.507,0,0,0-.111.168L8.523,14.818a.5.5,0,0,0,.111.54.519.519,0,0,0,.539.11l3.535-1.414a.5.5,0,0,0,.168-.111L20.69,6.13a.5.5,0,0,0,0-.707Z', 'M23.165,3.654a2,2,0,0,0,0-2.828,2.048,2.048,0,0,0-2.828,0L19.276,1.887a.531.531,0,0,0-.042.063.49.49,0,0,0-.105.29.5.5,0,0,0,.147.354L21.4,4.715a.483.483,0,0,0,.649.039.452.452,0,0,0,.058-.039Z']],
  Pencil: ['pencil', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.187,3.511a.514.514,0,0,0-.707,0L4.067,14.924a.5.5,0,0,0,0,.707l4.28,4.28a.5.5,0,0,0,.707,0L20.467,8.5a.5.5,0,0,0,0-.707Z', 'M3,16.71a.5.5,0,0,0-.828.2l-2.14,6.42a.5.5,0,0,0,.12.512.508.508,0,0,0,.512.121l6.42-2.139a.5.5,0,0,0,.2-.829Z', 'M22.968,1.017a3.613,3.613,0,0,0-4.988,0l-.712.713a.5.5,0,0,0,0,.707l4.279,4.28a.5.5,0,0,0,.707,0L22.968,6A3.53,3.53,0,0,0,22.968,1.017Z']],
  Pencil1: ['pencil-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.067,3.986a.5.5,0,0,0-.354-.148h0a.5.5,0,0,0-.354.147L3.437,14.91a.5.5,0,0,0,0,.707l4.948,4.948a.5.5,0,0,0,.707,0L20.009,9.648a.5.5,0,0,0,0-.706Z', 'M2.43,16.8a.5.5,0,0,0-.489-.127.5.5,0,0,0-.351.364L.084,23.314a.5.5,0,0,0,.133.47.507.507,0,0,0,.47.132l6.272-1.5a.5.5,0,0,0,.237-.84Z', 'M23.2,2.924,21.077.8a2.5,2.5,0,0,0-3.532,0L16.127,2.217a.5.5,0,0,0,0,.707l4.95,4.949a.5.5,0,0,0,.707,0L23.2,6.454A2.5,2.5,0,0,0,23.2,2.924Z']],
  PencilWrite2Alternate: ['pencil-write-2-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M20,11.5a1,1,0,0,0-1,1V21a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V4A1,1,0,0,1,3,3H13a1,1,0,0,0,0-2H3A3,3,0,0,0,0,4V21a3,3,0,0,0,3,3H18a3,3,0,0,0,3-3V12.5A1,1,0,0,0,20,11.5Z', 'M23.415.582a2.018,2.018,0,0,0-2.828,0L10.3,10.871a.5.5,0,0,0-.111.168L8.772,14.574a.5.5,0,0,0,.111.539.509.509,0,0,0,.539.112l3.536-1.415a.513.513,0,0,0,.168-.111L23.415,3.41A2,2,0,0,0,23.415.582Z']],
  PencilCircleAlternate: ['pencil-circle-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.862,8.226a.514.514,0,0,0-.707,0L7.263,14.118a.523.523,0,0,0-.111.168L6.036,17.078a.5.5,0,0,0,.11.539.51.51,0,0,0,.54.11l2.791-1.116a.483.483,0,0,0,.168-.111l5.893-5.892a.5.5,0,0,0,.146-.353.505.505,0,0,0-.146-.354Z', 'M16.58,5.5h0a1.677,1.677,0,0,0-1.191.493l-.838.838a.5.5,0,0,0,0,.707l1.675,1.675a.5.5,0,0,0,.707,0l.838-.837A1.685,1.685,0,0,0,16.58,5.5Z', 'M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z']],
  PencilWrite2: ['pencil-write-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.732,15.263a2,2,0,0,1-.671.443L9.526,17.12a2,2,0,0,1-2.6-2.6l1.415-3.535a2,2,0,0,1,.442-.672L15.6,3.5H3.572A3.121,3.121,0,0,0,.454,6.617V20.383A3.122,3.122,0,0,0,3.572,23.5H17.337a3.121,3.121,0,0,0,3.117-3.117V8.541Z', 'M20.133,1.085,9.844,11.374a.513.513,0,0,0-.111.168L8.319,15.077a.5.5,0,0,0,.111.54.507.507,0,0,0,.539.11L12.5,14.313a.5.5,0,0,0,.168-.111L22.96,3.914a2,2,0,1,0-2.827-2.829Z']],
  QuillWrite1: ['quill-write-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12.138,15.4,7.932,19.6a2.612,2.612,0,0,1-3.23.433A2.515,2.515,0,0,1,4.3,16.172L8.6,11.864A15.869,15.869,0,0,1,11,5.321a.245.245,0,0,0-.2-.382H1.562a1.5,1.5,0,0,0-1.5,1.5v16a1.5,1.5,0,0,0,1.5,1.5h16a1.5,1.5,0,0,0,1.5-1.5V13.206a.245.245,0,0,0-.382-.2A15.873,15.873,0,0,1,12.138,15.4Z', 'M23.42.061a14.744,14.744,0,0,0-6.31,1.678A.257.257,0,0,0,16.976,2L17.3,4.453a.5.5,0,0,1-.774.482L14.657,3.68a.246.246,0,0,0-.316.031c-.357.365-1.265,1.3-1.327,1.373A13.355,13.355,0,0,0,11.348,7.76a14.279,14.279,0,0,0-.872,2.38q-.164.6-.276,1.22c-.036.2-.069.4-.1.6-.015.11,0,.525-.072.6L5.355,17.232a1,1,0,0,0,0,1.414,1.012,1.012,0,0,0,1.414,0l4.676-4.676a14,14,0,0,0,8.508-3.912A14.137,14.137,0,0,0,23.938.579a.5.5,0,0,0-.146-.372A.493.493,0,0,0,23.42.061Z']],
  PencilWrite1: ['pencil-write-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.616,15.186a1.989,1.989,0,0,1-.969.53c-.07.038-3.236,1.325-3.238,1.326A2.046,2.046,0,0,1,7.252,16.6a2,2,0,0,1-.443-2.157S8.1,11.275,8.136,11.205a1.978,1.978,0,0,1,.53-.968l6.259-6.261a.25.25,0,0,0-.176-.427H3.7A3.118,3.118,0,0,0,.579,6.667V20.432A3.117,3.117,0,0,0,3.7,23.549H17.461a3.118,3.118,0,0,0,3.118-3.118V8.826a.25.25,0,0,0-.427-.176Z', 'M21.431.451a1.974,1.974,0,0,0-1.415.557L18.955,2.069a.5.5,0,0,0,0,.707L21.076,4.9a.5.5,0,0,0,.707,0l1.06-1.061a2.02,2.02,0,0,0,0-2.828A2,2,0,0,0,21.431.451Z', 'M17.858,3.871a.516.516,0,0,0-.707,0l-6.363,6.365a.5.5,0,0,0,0,.707l2.121,2.121a.5.5,0,0,0,.707,0L19.98,6.7a.5.5,0,0,0,0-.707Z', 'M11.882,14.438a.5.5,0,0,0,.168-.819L10.232,11.8a.5.5,0,0,0-.454-.137.5.5,0,0,0-.364.3L8.2,15a.5.5,0,0,0,.65.65Z']],
  PenWritePaper: ['pen-write-paper', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19,13a1,1,0,0,0-1,1v3H15a2,2,0,0,0-2,2v3H3a1,1,0,0,1-1-1V3A1,1,0,0,1,3,2h7a1,1,0,0,0,0-2H3A3,3,0,0,0,0,3V21a3,3,0,0,0,3,3H13a1.986,1.986,0,0,0,1.414-.586l5-5A2.008,2.008,0,0,0,20,17V14A1,1,0,0,0,19,13Z', 'M8.73,12.521a.5.5,0,0,0-.353.361L7.82,15.119,6.568,16.371a.75.75,0,0,0,1.06,1.061L8.892,16.17l2.207-.555a.5.5,0,0,0,.36-.35.5.5,0,0,0-.127-.487L9.217,12.65A.5.5,0,0,0,8.73,12.521Z', 'M23.707.293a1,1,0,0,0-1.414,0l-.9.9a2.011,2.011,0,0,0-1.533.208l-.052-.051a3,3,0,0,0-4.235.006L11.961,4.961a1,1,0,0,0,0,1.414,1.012,1.012,0,0,0,1.415,0L17,2.761a1,1,0,0,1,1.407.007l-.707.707a.5.5,0,0,0,0,.707L19.818,6.3a.5.5,0,0,0,.707,0l1.768-1.768a2,2,0,0,0,.517-1.93l.9-.9A1,1,0,0,0,23.707.293Z', 'M12.4,14.22a.5.5,0,0,0,.353-.147l6.356-6.355a.5.5,0,0,0,0-.707L16.99,4.889a.514.514,0,0,0-.707,0L9.927,11.245a.5.5,0,0,0,0,.707l2.121,2.121A.5.5,0,0,0,12.4,14.22Z']]
};
exports["default"] = _default;